<template>
  <div class="finance-base-bill payment-msg-bill">
    <div class="header">
      <div class="btn-container">
        <el-button
          v-if="curAuth.includes('addPayMsg')"
          :disabled="!outerItem"
          type="primary"
          icon="el-icon-plus"
          @click="addPaymentInfo"
        >{{ $t('payment_msg_bill_tjfkxx') }}</el-button>
        <div
          class="money"
          v-if="curAuth.includes('total')"
        >
          <div class="key">{{ totalLabel }}：</div>
          <div class="val">￥{{ total }}</div>
        </div>
      </div>
    </div>
    <custom-table
      :slots="['buyerTradeResult', 'action', 'buyerTradeRemark']"
      class="bill-list"
      :tableCode="tableCode"
      :data="data"
      :filterArr="filterArr"
      @filter="filterChange"
      @sort="sortChange"
      @column="onColumn"
    >
      <template v-slot:buyerTradeResult="scope">
        <el-button
          v-if="scope.row.attachs && scope.row.attachs.length"
          type="text"
          size="mini"
          @click="onPreview(scope)"
        >{{ $t('com_detail') }}</el-button>
      </template>
      <template
        v-if="showAction"
        v-slot:action="scope"
      >
        <span></span>
        <el-button
          v-if="curAuth.includes('del')"
          type="text"
          size="mini"
          @click="del(scope)"
          :disabled="!!scope.row.sellerTradeCode"
        >{{ $t('com_delete') }}</el-button>
        <el-button
          v-if="curAuth.includes('edit')"
          type="text"
          size="mini"
          @click="edit(scope)"
          :disabled="!!scope.row.sellerTradeCode"
        >{{ $t('com_edit') }}</el-button>
        <el-button
          v-if="curAuth.includes('relativeFlow') && !scope.row.sellerTradeCode"
          type="text"
          size="mini"
          @click="relative(scope.row)"
        >{{ $t('payment_msg_bill_glls') }}</el-button>
        <el-button
          v-if="curAuth.includes('relativeFlow') && scope.row.sellerTradeCode"
          type="text"
          size="mini"
          @click="onDelBankFlow(scope.$index, !scope.row.tradeId )"
        >{{ $t('payment_msg_bill_jcgl') }}</el-button>
      </template>
      <template v-slot:buyerTradeRemark="scope">
        {{scope.row.buyerTradeRemark | tradeRemark}}
      </template>
    </custom-table>
    <div class="footer">
      <div
        v-if="curAuth.includes('rest')"
        class="rest"
      >
        <el-checkbox-group
          v-model="userType"
          size="small"
          :disabled="restDisabled"
        >
          <el-checkbox
            v-if="curAuth.includes('rest')"
            :label="1"
            border
          >
            <div
              class="check-balance"
              @click.stop="checkBalance"
            >{{ $t('payment_msg_bill_syzlye') }} ￥{{ balance }}</div>
          </el-checkbox>
        </el-checkbox-group>
      </div>

      <div
        v-if="curAuth.includes('expectUseRest')"
        class="total"
      >
        <div class="key">{{ $t('payment_msg_bill_yjsyyk') }}：</div>
        <div class="val">￥{{ Math.max(expectUseRest, 0) }}</div>
      </div>
      <div
        v-if="curAuth.includes('paymentTotal')"
        class="total"
      >
        <div class="key">{{ $t('payment_msg_bill_bcfkjehj') }}：</div>
        <div class="val">￥{{ paymentTotal }}</div>
      </div>
      <div
        v-if="curAuth.includes('actualPayment')"
        class="total"
      >
        <div class="key">{{ $t('payment_msg_bill_ben_ci_shi_fu') }}：</div>
        <div class="val">￥{{ actualPayment }}</div>
      </div>
      <div
        v-if="curAuth.includes('expectRest')"
        class="total"
      >
        <div class="key">{{ $t('payment_msg_bill_yu_ji_jie_yu') }}：</div>
        <div class="val">￥{{ expectRest }}</div>
      </div>
    </div>
    <img-detail-dialog
      v-if="showImgPreview"
      @close="showImgPreview = false"
      :imgData="imgPreviewData"
    ></img-detail-dialog>

  </div>
</template>

<script>
/** 付款信息 */

import imgDetailDialog from '@/components/imgDetailDialog';
import apis from '@/utils/apis';
import billMixin from './billMixin';

// payment_msg_bill_tjfkxx: 添加付款信息// payment_msg_bill_glls: 关联流水// payment_msg_bill_jcgl: 解除关联// payment_msg_bill_syzlye: 使用租赁余额// payment_msg_bill_yjsyyk: 预计使用余款// payment_msg_bill_bcfkjehj: 本次付款金额合计// payment_msg_bill_ben_ci_shi_fu: 本次实付// payment_msg_bill_yu_ji_jie_yu: 预计结余// payment_msg_bill_xjzfjexj: 现金支付金额小计// payment_msg_bill_dgzzjexj: 对公转账金额小计// payment_msg_bill_jyjehj: 交易金额合计// payment_msg_bill_fkrmz: 付款人名字// payment_msg_bill_skrmz: 收款人名字// payment_msg_bill_fkzh: 付款账号// payment_msg_bill_skzh: 收款账号// payment_msg_bill_nqdyscxzdyhlsm: 您确定要删除选中的银行流水吗？

export default {
  name: '',
  mixins: [billMixin],
  components: { imgDetailDialog, },
  props: {
    billType: [Number, String],
    // 余额-权限配置rest时必填
    balance: [Number, String],
    // 押金-权限配置deposit时必填
    deposit: [Number, String],
    // 交易订单id-新增，编辑付款信息时必填
    orderNum: [Number, String],
    // 交易方式-传入则限制交易方式选择（无付款信息情况下）
    tradeMethod: [Number, String],
    // 外部应付列表选中项-必填项
    outerItem: {
      type: Object
    },
    // 必填- 应收金额合计
    payableTotal: {
      type: Number,
      required: true,
      default: 0
    },
    /**
     * payment_msg_bill:付款方，付款账号，收款方，收款账号，交易金额，交易日期，摘要，交易凭证，操作
     * payment_msg_bill2：交易方式，付款方，付款账号，收款方，收款账号，交易金额，交易日期，摘要，交易凭证，操作
     * payment_msg_bill3：交易方式，付款方，付款账号，收款方，收款账号，交易金额，交易日期，摘要，交易凭证，操作时间，操作人
     * payment_msg_bill4：付款方，付款账号，收款方，收款账号，交易金额，交易日期，摘要，交易凭证，操作时间，操作人
     */
    tableCode: {
      type: String,
      default: 'payment_msg_bill'
    },
    // 账单详情-预算结余时必填
    billInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    restDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    totalLabel() {
      if (this.data.length) {
        if (this.dicCodeValue.payment_class) {
          const firstItem = this.data[0];
          if (`${firstItem.tradeMethod}` === `${this.dicCodeValue.payment_class.cash}`) {
            return this.$t('payment_msg_bill_xjzfjexj');
          } else {
            return this.$t('payment_msg_bill_dgzzjexj');
          }
        }
      }
      return this.$t('payment_msg_bill_jyjehj');
    },
    // 本次预计使用余额
    expectUseRest() {
      const payableTotal = this.payableTotal || 0;
      const tradeTotal = this.total || 0;
      const balance = this.userType.includes(1) ? this.balance || 0 : 0;
      const ret = payableTotal - tradeTotal >= balance ? balance : payableTotal - tradeTotal;
      // return Math.max(ret, 0);
      return ret;
    },
    // 本次付款金额合计
    paymentTotal() {
      const tradeTotal = this.total || 0;
      const expectUseRest = this.expectUseRest || 0;
      return tradeTotal + expectUseRest;
    },
    // 本次实付
    actualPayment() {
      const tradeTotal = this.total || 0;
      return tradeTotal;
    },
    // 预计结余 付款金额合计 - 应付金额合计 + （使用余额 - 预计使用余额）
    expectRest() {
      const billInfo = this.billInfo;
      const billPayment = billInfo.billPayment || {};
      const partnerBalance = billInfo.partnerBalance || {};
      const tradeState = billPayment.tradeState || 1;
      const balanceAmount = partnerBalance.balanceAmount || 0;
      const lockAmount = partnerBalance.lockAmount || 0;
      if (tradeState <= 6) {
        const paymentTotal = this.paymentTotal || 0;
        const payableTotal = this.payableTotal || 0;
        const balance = this.balance || 0;
        const expectUseRest = this.expectUseRest || 0;
        const ret = (paymentTotal - payableTotal >= 0 ? paymentTotal - payableTotal : 0) + (balance - expectUseRest);
        return Math.max(0, ret);
      }

      return balanceAmount - lockAmount;
    },
    total() {
      return this.getTotal('totalAmount');
    },
    amount() {
      if (this.total !== undefined) {
        if (this.userType.includes(1)) {
          return this.total + this.balance;
        }
        return this.total;
      }
      return 0;
    }
  },
  data() {
    return {
      totalAmount: '',
      userType: [],
      tableList: [],
      showActionAuth: ['del', 'edit'],
      fullAuth: [
        // relativeFlow 关联流水（仅退押金登记适用）
        // 交易金额合计
        'total',
        // 添加付款信息
        'addPayMsg',
        // 编辑
        'edit',
        // 删除
        'del',
        // 使用余额
        'rest',
        // 本次预付预计使用余款
        'expectUseRest',
        // 本次付款金额合计
        'paymentTotal',
        // 本次实付
        'actualPayment',
        // 预计结余
        'expectRest'
      ],
      defaultAuth: [],
      dialogVisible: false,
      dialogModel: {},
      editIndex: 0,
      imgPreviewData: [],
      showImgPreview: false,
      showBalanceDetail: false,
      // 关联银行流水
      dialogVisible2: false,
      dialogModel2: {},
      tableColumn: []
    };
  },
  watch: {
    tableCode: {
      immediate: true,
      handler() {
        // this.getTableColumn();
      }
    },
    data() {
      this.initTableColumn();
    },
    billInfo: {
      immediate: true,
      handler(data) {
        if (data.billPayment && data.billPayment.isUseBalance) {
          this.selRest();
        }
      }
    }
  },
  filters: {
    tradeRemark(val) {
      if (!val) {
        return '-';
      }
      return val.slice(0, 6);
    }
  },
  directives: {},
  methods: {
    onColumn({ tableColumn }) {
      this.tableColumn = tableColumn;
    },
    // 如果支付类型是现金，则付款账号显示付款人名字,收款账号显示收款人名字
    initTableColumn() {
      if (this.tableColumn && this.tableColumn.length && this.data && this.data.length && this.dicCodeValue.payment_class) {
        const item = this.data[0];
        const buyer = this.tableColumn.find(obj => obj.columnCode === 'buyerAccount');
        const seller = this.tableColumn.find(obj => obj.columnCode === 'sellerAccount');
        if (`${item.tradeMethod}` === `${this.dicCodeValue.payment_class.cash}`) {
          if (buyer) {
            buyer.columnName = this.$t('payment_msg_bill_fkrmz');
          }
          if (seller) {
            seller.columnName = this.$t('payment_msg_bill_skrmz');
          }
          this.tableColumn = [
            ...this.tableColumn
          ];
        } else {
          if (buyer) {
            buyer.columnName = this.$t('payment_msg_bill_fkzh');
          }
          if (seller) {
            seller.columnName = this.$t('payment_msg_bill_skzh');
          }
          this.tableColumn = [
            ...this.tableColumn
          ];
        }
      }
    },
    checkBalance() {
      /**
       * 账单类型
         租赁 10   =》  12
         押金 11  =》 11
         违约金 12  =》 21
         逾期费 13  =》 22
         租金退还 20 没有余额可用
         押金退还 21  没有余额可用
         库存管理费 100  =》 23
       */
      if (!this.billType || [20, 21].includes(this.billType)) {
        return;
      }
      this.showBalanceDetail = true;
    },
    addPaymentInfo() {
      const firstItem = this.data[0];
      this.dialogModel = {
        type: 'add',
        data: {
          outerItem: this.outerItem,
          form: {
            tradeMethod: firstItem ? firstItem.tradeMethod : this.tradeMethod
          },
          orderNum: this.orderNum
        }
      };
      this.totalAmount = Math.max(this.payableTotal - this.amount, 0);
      this.dialogVisible = true;
    },
    // 删除
    del(scope) {
      this.delRow(scope.$index);
    },
    edit(scope) {
      this.editIndex = scope.$index;
      this.dialogModel = {
        type: 'edit',
        data: {
          outerItem: this.outerItem,
          form: scope.row,
          orderNum: this.orderNum
        }
      };
      this.dialogVisible = true;
    },
    // 关联流水
    relative(row) {
      this.dialogModel2 = {
        data: row
      };
      this.dialogVisible2 = true;
    },
    // 取消关联流水
    onDelBankFlow(index, isLocal) {
      this.$showConfirm(this.$t('payment_msg_bill_nqdyscxzdyhlsm')).then(() => {
        const curBankFlow = this.data[index];
        if (isLocal) {
          this.$message({
            type: 'success',
            message: this.$t('com_delete_success')
          });
          curBankFlow.sellerTradeCode = '';
          this.$emit('success', { type: 'delete', sellerTradeCode: curBankFlow.sellerTradeCode }, true);
          return;
        }
        this.$postJSON(`${apis.billPaymentBankFlowDelete}/${curBankFlow.sellerTradeCode}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('com_delete_success')
          });
          this.$emit('success', { type: 'delete', sellerTradeCode: curBankFlow.sellerTradeCode });
          curBankFlow.sellerTradeCode = '';
        });
      });
    },
    // 确定关联流水（需考虑本地情况）
    onBind(bankItem, isLocal) {
      this.$set(this.dialogModel2.data, 'sellerTradeCode', bankItem.sellerTradeCode);
      this.$emit('success', bankItem, isLocal);
    },
    onAdd(newData) {
      this.addRow(newData);
    },
    onEdit(newData) {
      this.splice(this.editIndex, 1, newData);
    },
    // 查看交易凭证
    onPreview(scope) {
      this.imgPreviewData = scope.row.attachs;
      this.showImgPreview = true;
    },
    // 是否使用了余额
    isUseRest() {
      return this.userType.includes(1);
    },
    // 是否使用了押金
    isUseDeposit() {
      return this.userType.includes(2);
    },
    // 选中余额
    selRest() {
      this.userType.push(1);
    },
    getRest() {
      if (this.userType.includes(1)) {
        return this.balance;
      }
      return 0;
    },
    getDeposit() {
      if (this.userType.includes(2)) {
        return this.deposit;
      }
      return 0;
    }
  },
  created() { },
  mounted() {
    this.mergeLanguage(null, 'portal_payment_msg_bill');
    this.getDictionaryCodeValue('payment_class');
    // this.getCompLanguage(null, 'payment_msg_bill');
  }
};
</script>

<style lang="scss">
.payment-msg-bill {
  .check-balance {
    text-decoration: underline;
    display: inline-block;
  }
}
</style>
